module.exports = require("resize-observer-polyfill");;